import { render } from "./Covid19Forms.vue?vue&type=template&id=86d9f196&scoped=true"
import script from "./Covid19Forms.vue?vue&type=script&lang=js"
export * from "./Covid19Forms.vue?vue&type=script&lang=js"

import "./Covid19Forms.vue?vue&type=style&index=0&id=86d9f196&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-86d9f196"]])

export default __exports__